import { ref } from 'vue'
import { defineStore } from 'pinia'
import { searchApi } from '../api/search.api'
import { useUserStore } from '@/modules/user/stores/user.store'
import type { SearchHit, SearchBox } from '../interfaces/search'

export const useSearchStore = defineStore('search', () => {
  const userStore = useUserStore()
  const isSearchActive = ref<boolean>(false)
  const relatedId = ref<number>()
  const searchQuery = ref<string>('')
  const filterText = ref<string>('')

  const mapClient = (
    boxes: SearchBox[],
    clienKey: string,
    clientName: string,
    returnClientName?: string,
    returnClientKey?: string,
  ): SearchHit => {
    return {
      boxes: boxes,
      clientKey: clienKey,
      clientName: clientName,
      returnClientName: returnClientName,
      returnClientKey: returnClientKey,
    }
  }

  const getSearchClients = (result: { [item: string]: SearchBox[] }) => {
    return Object.entries(result).flatMap<SearchHit>(([key, value]) => {
      const client = userStore.clients.find((client) => client.clientKey === key)
      if (client) {
        return mapClient(value, client.clientKey, client.clientName)
      } else {
        const returnClient = userStore?.clients.find((client) => client.returnClientKey === key)
        if (returnClient?.returnClientKey && returnClient?.returnClientName) {
          return mapClient(
            value,
            returnClient.clientKey,
            returnClient.clientName,
            returnClient.returnClientName,
            returnClient.returnClientKey,
          )
        }
      }
      return []
    })
  }

  const getSearchResult = async (): Promise<SearchHit[]> => {
    searchQuery.value = searchQuery.value.trim()
    const { data } = await searchApi.getSearchResult({ query: searchQuery.value })
    if (data && data.query === searchQuery.value) {
      searchQuery.value = data.query
      return getSearchClients(data.searchResult)
    }
    return []
  }

  return {
    getSearchResult,
    isSearchActive,
    relatedId,
    searchQuery,
    filterText,
  }
})
